import { render, staticRenderFns } from "./GatewayList.vue?vue&type=template&id=2db391fc&scoped=true&lang=pug"
import script from "./GatewayList.vue?vue&type=script&lang=ts"
export * from "./GatewayList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2db391fc",
  null
  
)

export default component.exports